<template>  
    <div>
        <SubmissionModal ref="submissionmodal" @cross_clicked="dismissModal"></SubmissionModal>
        
        <div class="content-start">
            <div class="container-fluid" id="main-container">
                <div class="row" id="challenge-content">
                    <NavBarLight></NavBarLight>
                    <div class="col-md-12 mx-auto">
                        <h5>Top submissions for <b>{{challengeObj['.key']}}</b></h5><br><br>                      
                        <div v-for="(submission, index) in reversedSubmissions"
                            :key="index" class="results-card">
                            <ResultsCard @results_card_clicked="resultClicked(submission)"
                                :photo="submission.photoURL"
                                :name="submission.name"
                                :upvotes="submission.upvotes"
                                :gold="submission.GOLD"
                                :silver="submission.SILVER"
                                :bronze="submission.BRONZE"
                                :displayImg="submission.display_img_url">
                                
                            </ResultsCard>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
    
<script>
import NavBarLight from '@/components/NavBarLight.vue'
import firebase from '../services/firebase'
import ResultsCard from '@/components/ResultsCard.vue'
import SubmissionModal from '@/components/SubmissionModal.vue'

export default {
    name: 'Results',
    components: {
        NavBarLight,
        ResultsCard,
        SubmissionModal
    },
    data: function() {
        return {
            slug: '',
            submissions: null
        }  
    },
    firebase: {
         challenges: firebase.database().ref('challenges/UX').orderByChild('Enabled').equalTo(true)
    },
    computed: {
        challengeObj : function() {
            for (var key in this.challenges) {
                console.log("slug is " + this.challenges[key].Slug);
                if (this.challenges[key].Slug == this.$route.params.slug) {
                    console.log("slug is matched for " + this.challenges[key].Slug);
                    return this.challenges[key];
                }
            }
        },

        reversedSubmissions: function() {
            return this.submissions.reverse();
        }
    },
    created: function() {
        this.slug = this.$route.params.slug;
        this.$bindAsArray('submissions', firebase.database().ref('submissions/challenges/' + this.$route.params.slug).orderByChild('upvotes'));
    },
    methods: {
        resultClicked: function(sub) {
            //alert("in results, resultsClicked card clicked, name is " + sub.name + " and upvotes are " + sub.upvotes);
            this.$refs.submissionmodal.show(sub);
        },
        dismissModal: function() {
            this.$refs.submissionmodal.hide();
        }
    }
}
</script>


<style scoped>
    .content-start {
        margin-top:58px;
    }

    #main-container {
        color:#444;
        background-color:#f8faff !important;
    }

    #challenge-content {
        margin-left:3.5%;
        margin-right:4%;
        padding-right:0%;
        margin-top: 20px;
    }


    .results-card {
        display: inline-block;
        width:25%;
        margin-right: 5%;
        cursor:pointer;
    }

    @media (min-width: 993px) and (max-width: 1100px) {
       .results-card {
            display: inline-block;
            width:30%;
            margin-right: 5%;
            cursor:pointer;
        } 
   
    }

    @media (min-width: 800px) and (max-width: 992px) {
       .results-card {
            display: inline-block;
            width:35%;
            margin-right: 5%;
            cursor:pointer;
        } 
   
    }

    @media (min-width: 740px) and (max-width: 800px) {
        .results-card {
            display: inline-block;
            width:40%;
            margin-right: 5%;
            cursor:pointer;
        }
    }

    @media (min-width: 600px) and (max-width: 740px) {
        .results-card {
            display: inline-block;
            width:45%;
            margin-right: 5%;
            cursor:pointer;
        }
    }

    @media (min-width: 520px) and (max-width: 600px) {
        .results-card {
            display: inline-block;
            width:60%;
            margin-right: 5%;
            cursor:pointer;
        }
    }

    @media (min-width: 400px) and (max-width: 519px) {
        .results-card {
            display: inline-block;
            width:80%;
            margin-right: 5%;
            cursor:pointer;
        }
    }

    @media (max-width: 400px) {
        .results-card {
            display: inline-block;
            width:90%;
            margin-right: 5%;
            cursor:pointer;
        }
    }



</style>
